<footer class="bg-dark position-relative">
  <!--div class="container">
    <div class="footer-content pt-5 pb-5">
      <div class="row">
        <div class="col-xl-4 col-lg-4 mb-50">
          <div class="footer-widget">
            <div class="footer-logo mb-3">
              <a class="pe-3 text-white" [routerLink]="['/']"
                ><img
                  src="/assets/icons/device-fav.svg"
                  alt=""
                  width="50"
                  height="50"
                  class="me-2"
                />Scenario Library
              </a>
            </div>
            <div class="footer-text">
              <p>The brower based branching content authoring tool.</p>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 mb-30">
          <div class="footer-widget">
            <div class="footer-widget-heading">
              <h3>Useful Links</h3>
            </div>
            <ul>
              <li><a [routerLink]="['/home']">Home</a></li>
              <li><a [routerLink]="['/home']" fragment="features">Features</a></li>
              <li><a [routerLink]="['/home']" fragment="examples">Examples</a></li>
              <li><a [routerLink]="['/home']" fragment="services">Services</a></li>
              <li><a [routerLink]="['/help']">Help</a></li>
            </ul>
          </div>
        </div>
        <div class="col-xl-4 col-md-4 mb-3">
          <div class="single-cta mb-4">
            <i class="bx bx-envelope"></i>
            <div class="cta-text">
              <h4>Email us</h4>
              <a href="mailto:hello@yoscenario.com">hello@yoscenario.com</a>
            </div>
          </div>
          <div class="single-cta mb-4">
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
              class="r-1nao33i r-4qtqp9 r-yyyyoo r-16y2uox r-8kz0gk r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-lrsllp"
            >
              <g>
                <path
                  d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                ></path>
              </g>
            </svg>
            <div class="cta-text">
              <h4>Follow us</h4>
              <a href="https://twitter.com/yoscenario">@yoscenario</a>
            </div>
          </div>
          <div class="single-cta">
            <i class='bx bxl-youtube'></i>
            <div class="cta-text">
              <h4>Watch us</h4>
              <a href="https://www.youtube.com/@yoscenario">@yoscenario</a>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  </div>
  <hr-->
  <div class="copyright-area">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6 text-lg-left text-center">
          <div class="copyright-text">
            <p>&copy; Yo Scenario Ltd {{ now | date : "Y" }}</p>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 d-none d-lg-block text-center">
          <div class="footer-menu">
            <ul>
              <li><a href="mailto:support@yoscenario.com">Help</a></li>
              <li><a href="https://app.yoscenario.com/terms" target="_blank">Terms</a></li>
              <li><a href="https://app.yoscenario.com/privacy" target="_blank">Privacy</a></li>
              <li><a href="https://app.yoscenario.com/cookies" target="_blank">Cookies</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>